"use client";
import Link from "next/link";
import { ChevronLeft, Clock4, Ribbon } from "lucide-react";
import SwiperComponent from "@/components/ui/swiper-component";
import BlogCard from "@/components/BlogCard";
import Title from "../Title";
import DeviceOnly from "@/components/DeviceOnly";

export default function SliderBlog({ collection_data, fields, storage_prefix_url, limit = 10, isHome, isSidebar, isSliderCategory }) {

    // بلاگ‌ها همراه ویجت از کوئری صفحه (getPrefixUrlDetails) می‌آیند؛ fetch کلاینتی نداریم
    const blogs = collection_data?.blogs || [];

    const slides = blogs.slice(0, limit).map((blog) => (
        <BlogCard
            key={blog.id}
            blog={blog}
            isHome={isHome}
            isCardSlider={true}
            storage_prefix_url={storage_prefix_url}
        />
    ));

    const mobile_gutter = isSliderCategory ? "" : "px-4 md:px-10 lg:px-0";
    const mobile_swiper_gutter = isSliderCategory ? "" : "px-4! md:px-10! lg:px-0!";

    return (
        <div className={`${isHome ? "" : "mb-10"}`}>
            <DeviceOnly on="mobile">
                <div className="block lg:hidden w-full mx-auto">

                    {/* Header */}
                    <div className={`flex items-center justify-between pb-4 ${mobile_gutter}`}>
                        <div className="flex items-center gap-2">
                            {fields?.icon === "clock" ? <Clock4 size={20} /> : fields?.icon === "ribbon" ? <Ribbon size={20} /> : ""}

                            <Title
                                type={fields?.title?.type}
                                className={`flex items-center text-jmt-main font-bold text-base ${!isHome && "border-b-2 border-jmt-primary-800"}`}>
                                {fields?.title?.title || ""}
                            </Title>
                        </div>

                        {fields?.link?.url &&
                            <Link
                                href={fields?.link?.url || "#"}
                                className="flex items-center text-xs lg:text-sm font-bold text-jmt-neutral-800 hover:text-black transition lg:gap-1"
                            >
                                {fields?.["text-link"]}
                                <ChevronLeft size={18} />
                            </Link>}
                    </div>

                    {/* Blog Slider */}
                    {isHome ? <SwiperComponent
                        slides={slides}
                        breakpoints={{
                            400: { slidesPerView: 2.2, spaceBetween: 12 },
                            480: { slidesPerView: 2.5, spaceBetween: 12 },
                            768: { slidesPerView: 3.5, spaceBetween: 12 },
                        }}
                        slidesPerView={1.5}
                        spaceBetween={8}
                        navigation={false}
                        grabCursor={true}
                        swiper_className={mobile_swiper_gutter}
                    />
                        : <SwiperComponent
                            slides={slides}
                            breakpoints={{
                                400: { slidesPerView: 1.5, spaceBetween: 16 },
                                480: { slidesPerView: 2.5, spaceBetween: 16 },
                                768: { slidesPerView: 3, spaceBetween: 16 },
                            }}
                            slidesPerView={1.5}
                            spaceBetween={16}
                            navigation={false}
                            grabCursor={true}
                            swiper_className={mobile_swiper_gutter}
                        />}
                </div>
            </DeviceOnly>

            <DeviceOnly on="desktop">
                <div className="hidden lg:block">
                    <div className={`${isHome ? "container" : ""}`}>

                        {/* Header */}
                        <div className="flex items-center justify-between pb-4">
                            <div className="flex items-center gap-2">
                                {fields?.icon === "clock" ? <Clock4 size={26} /> : fields?.icon === "ribbon" ? <Ribbon size={26} /> : ""}
                                <Title
                                    type={fields?.title?.type}
                                    className={`flex items-center text-jmt-main font-bold text-base ${isHome ? "md:text-xl" : "md:text-lg border-b-2 border-jmt-primary-800"}`}
                                >
                                    {fields?.title?.title || ""}
                                </Title>
                            </div>

                            {fields?.link?.url &&
                                <Link
                                    href={fields?.link?.url || "#"}
                                    className="flex items-center text-xs lg:text-sm font-bold text-jmt-neutral-800 hover:text-black transition lg:gap-1">
                                    {fields?.["text-link"]}
                                    <ChevronLeft size={18} />
                                </Link>}
                        </div>

                        {/* Blog Slider */}
                        {isSidebar ? <SwiperComponent
                            slides={slides}
                            breakpoints={{
                                1024: { slidesPerView: 3, spaceBetween: 16 },
                                1300: { slidesPerView: 3, spaceBetween: 24 },
                            }}
                            slidesPerView={2.2}
                            spaceBetween={8}
                            navigation={true}
                            navPosition="side"
                            grabCursor={true}
                        /> : <SwiperComponent
                            slides={slides}
                            breakpoints={{
                                1024: { slidesPerView: 4, spaceBetween: 24 },
                                1300: { slidesPerView: 5, spaceBetween: 24 },
                            }}
                            slidesPerView={2.2}
                            spaceBetween={8}
                            navigation={true}
                            navPosition="side"
                            grabCursor={true}
                        />}
                    </div>
                </div>
            </DeviceOnly>
        </div>

    );
}
